import fetcher from 'common/fetcher';
import logger from 'common/logger';
import {IncomingMessage} from 'http';
import getApiUrl from 'next-api-url';
import useSWR, {ConfigInterface} from 'swr';
import {fetcherFn, responseInterface} from 'swr/dist/types';
import {DEVELOPMENT_HOST, IS_PRODUCTION, PRODUCTION_HOST} from './constants';

export const useSWRClient = <T, E = any>(
  key: string,
  initialData?: T,
  options?: ConfigInterface<T, any, fetcherFn<T>>
): responseInterface<T, E> =>
  useSWR<T, E>(key, {
    fetcher,
    initialData,
    onError: (error, key) => logger.error('useSWRClient', {key, error}),
    onSuccess: (data, key) => logger.info('useSWRClient', {key, data}),
    ...options,
  });

export const useSWRServer = async <T>(
  key: string,
  context:
    | {
        req: IncomingMessage;
      }
    | null
    | undefined,
  options?: RequestInit
): Promise<T> => {
  try {
    const url = getApiUrl(context, false);
    const data = await fetcher<T>(`${url}${key}`, options);
    logger.info('useSWRServer', {key, data});
    return data;
  } catch (error) {
    logger.error('useSWRServer', {key, error});
    return {} as T;
  }
};

export const useSWRStaticProps = async <T>(key: string, options?: RequestInit): Promise<T> => {
  try {
    const url = IS_PRODUCTION ? PRODUCTION_HOST : DEVELOPMENT_HOST;
    const data = await fetcher<T>(`${url}${key}`, options);
    logger.info('useSWRStaticProps', {key, data});
    return data;
  } catch (error) {
    logger.error('useSWRStaticProps', {key, error});
    return {} as T;
  }
};

export const useSWRPost = async <B, R>(key: string, body: B): Promise<R> => {
  try {
    const data = await fetcher<R>(key, {
      method: 'POST',
      body: JSON.stringify(body),
    });
    logger.info('useSWRPost', {key, body});
    return data;
  } catch (error) {
    logger.error('useSWRPost', {key, body});
    return {} as R;
  }
};
